import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wallet-aggregator',
  templateUrl: './wallet-aggregator.component.html',
  styleUrls: ['./wallet-aggregator.component.scss']
})
export class WalletAggregatorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/wallet-aggregator/wallet-aggregator.component.ts